import React, {memo, useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
//local
import SubHeading from "components/SubHeading";
import MiniSelect from "components/selects/MiniSelect";
import {IconCurrency} from "components/icons";

const DefaultCurrencySettings = memo(({settings, getCurrencies, onUpdate}) => {
  const {t} = useTranslation();

  const [currencies, setCurrencies] = useState([]);

  useEffect(() => {
    getCurrencies().then(setCurrencies);
  }, [getCurrencies]);

  return (
    <div className="organization-settings__default-currency mb-12">
      <SubHeading title="DEFAULT_CURRENCY" icon={<IconCurrency />} />
      <MiniSelect
        list={currencies ?? []}
        defaultValue={settings.defaultCurrencyCode ?? "SEK"}
        addClass="mt-4"
        fullWidthDropdownLabel
        onChange={(value) => onUpdate({defaultCurrencyCode: value})}
        label={t("SETTINGS_ORGANIZATION_CURRENCY_LABEL")}
        informationText="SETTINGS_ORGANIZATION_CURRENCY_TOOLTIP"
      />
    </div>
  );
});

export default DefaultCurrencySettings;
